export default __webpack_public_path__ + "static/finace-c25afc196df8b86675789607bb213f40.svg";